import React from 'react';

import SuccessMark from '../../images/SuccessMark';
import { PrimaryButton } from '../Buttons/PrimaryButton';
import { IInputOnChange, Input } from '../Inputs/Input';

import style from './SignUp.scss';

import cn from 'classnames';
import { isEmail } from 'utils/helpers';

interface ISignUpBannerProps {
  className?: string;
  btnText?: string;
}

interface ISignUpBannerState {
  email: string;
  errorMsg: string;
  isSending: boolean;
  isSubscribed: boolean;
}

const SUBSCRIBED_COOKIE_NAME = 'tsr_subscribed_at';

class SignUpBanner extends React.Component<ISignUpBannerProps, ISignUpBannerState> {
  constructor(props: ISignUpBannerProps) {
    super(props);
    this.state = {
      email: '',
      errorMsg: '',
      isSending: false,
      isSubscribed: false,
    };
  }

  componentDidMount() {
    if (document.cookie.includes(SUBSCRIBED_COOKIE_NAME)) {
      this.setState({ isSubscribed: true });
    }
  }

  handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const { email, isSending } = this.state;

    if (isSending) {
      return;
    }

    // Validate email address
    if (!isEmail(email)) {
      this.setState({ errorMsg: 'Invalid email address.' });
      return;
    }

    this.setState({ isSending: true });

    // Send payload
    fetch('https://p5erhrmlx5.execute-api.us-east-2.amazonaws.com/prod/TSRForms', {
      body: JSON.stringify({
        action: 'SUBSCRIBE',
        email,
        referrer: document.referrer,
        tags: ['SignUp'],
      }),
      method: 'POST',
    })
      .then((res) => {
        this.setState({ isSubscribed: true, isSending: false, email: '' });
        document.cookie = `${SUBSCRIBED_COOKIE_NAME}=${new Date().getTime()};path=/`;
      })
      .catch((err) => {
        this.setState({ errorMsg: err.message, isSending: false });
      });
  };

  handleInputChange = (input: IInputOnChange) => {
    this.setState({ email: input.value, errorMsg: '' });
  };

  render() {
    const { className, btnText } = this.props;
    const { email, errorMsg, isSubscribed, isSending } = this.state;

    return (
      <div className={cn(style.signUpBanner, className)}>
        <div className="container">
          <div className="row align-items-center">
            <div className="col-12 col-lg-5 offset-lg-1 col-xl-4">
              <h2>
                Never miss <br />a story
              </h2>
              <p>
                Sign up for Think Save Retire to be the first to receive{' '}
                <br className="d-none d-sm-block d-lg-none" />
                the most personal finance content you won’t find anywhere else.
              </p>
            </div>
            <div className="col-12 col-lg-5 offset-xl-1">
              {isSubscribed ? (
                <div className={style.successMessage}>
                  <SuccessMark />{' '}
                  <p>
                    Success! Now check your email <br />
                    to confirm your subscription.
                  </p>
                </div>
              ) : (
                <form onSubmit={this.handleSubmit}>
                  <div className="row">
                    <div className="col-12 col-sm-6 col-md-7">
                      <Input
                        value={email}
                        name="email"
                        className={style.inputWrapper}
                        onChange={this.handleInputChange}
                        placeholder="Email Address"
                        helperText={errorMsg}
                        hasError={errorMsg !== ''}
                      />
                    </div>
                    <div className="col-12 col-sm-6 col-md-5">
                      <PrimaryButton type="submit" isLoading={isSending}>
                        {btnText || 'Subscribe'}
                      </PrimaryButton>
                    </div>
                  </div>
                </form>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default SignUpBanner;
